import {
    CallToAction,
    Content,
    Email,
    Header,
    Paragraph,
    Title,
} from "@rakered/email";

export default function SetPasswordEmail(props) {
    return (
        <Email>
            <Content>
                <Header logo="https://www.sportsviz.com/email/logo512_large.png" />
                <Title>Choose your Password</Title>

                <Paragraph>{props.message}</Paragraph>
                <Paragraph>Press the button to choose your password.</Paragraph>
                <CallToAction href={props.link}>
                    Choose your password
                </CallToAction>
            </Content>
        </Email>
    );
}
